import { PureComponent } from 'preact-compat'
import { ComponentChild } from 'preact'
import Button from '@insided/control/uikit/Button'
import { ContentType, getConsistentContentType } from '@insided/shared/utils/contentType'
import {
  reportReply,
  reportTopic
} from '../services/topicService'
/* eslint-disable import/no-internal-modules */
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'
import TextArea from '@insided/deprecated-preact-components/design-system-components/text-area'
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@insided/deprecated-preact-components/design-system-components/modal'
import Phrase from '@insided/deprecated-libs/translationsUtils/phrase'
import { t } from '@insided/deprecated-libs/translationsUtils/translations'

export interface ReportContentModalProps {
  contentType: ContentType
  topicId?: number | null
  replyId?: number
  userId: number | null
  topicTitle: string
  showReportContentModal: (show: boolean) => void
  onShowAlert: (type: 'success' | 'error', message?: string | ComponentChild) => void
}

export interface ReportContentModalState {
  isLoading: boolean
  reason?: string
  error?: string | ComponentChild
}

class ReportContentModal extends PureComponent<ReportContentModalProps, ReportContentModalState> {
  constructor() {
    super()

    this.state = {
      isLoading: false,
      reason: undefined,
      error: undefined
    }

    this.onReport = this.onReport.bind(this)
    this.onContentChange = this.onContentChange.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  async onReport() {
    const { contentType, topicId, replyId, userId, showReportContentModal, onShowAlert } = this.props
    const { reason } = this.state

    if (!reason || reason === '') {
      this.setState({ error: <Phrase p='topic_view.reported_content_modal.reason_not_provided.error' /> })
      return
    }

    this.setState({ isLoading: true })

    try {
      if (replyId && userId) {
        await reportReply(userId, reason, getConsistentContentType(contentType), replyId)
      } else if (topicId && userId) {
        await reportTopic(userId, reason, getConsistentContentType(contentType), topicId)
      }
      onShowAlert('success', <Phrase p='topic_view.reported_content.success' />)
      showReportContentModal(false)
    } catch {
      onShowAlert('error', <Phrase p='topic_view.reported_content_modal.error' />)
    }

    this.setState({ reason: undefined, isLoading: false, error: undefined })
  }

  onContentChange(reason: string) {
    this.setState({ reason, error: undefined })
  }

  onCancel() {
    const { showReportContentModal } = this.props
    showReportContentModal(false)
    this.setState({ error: undefined })
  }

  render() {
    const { topicTitle } = this.props
    const { isLoading, error, reason } = this.state

    return (
      <Modal onClose={this.onCancel}>
        <ModalHeader title={<Phrase p='topic_view.reported_content_modal.report_content' />} />
        <ModalBody>
          <div className='form__row report-content--title'>
            <strong><Phrase p='topic_view.reported_content_modal.topic' /></strong>
            <p>
              {topicTitle}
            </p>
          </div>
          <div className='form__row report-content--note'>
            <p>
              <Phrase p='topic_view.reported_content_modal.note' />
            </p>
          </div>
          <div className='form__row report-content--reason'>
            <InputUnit
              label={<Phrase p='topic_view.reported_content_modal.reason' />}
              error={error ?? undefined}
            >
              <TextArea
                onContentChange={this.onContentChange}
                placeholder={t('Forum', 'topic_view.reported_content_modal.reason.placeholder')}
                size='fullWidth'
                value={reason}
                verticalResize
                maxLength={250}
              />
            </InputUnit>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            title={<Phrase p='topic_view.reported_content_option.report' />}
            className='btn btn-primary'
            onClick={this.onReport}
            isLoading={isLoading}
            size='medium'
            data-qa='report-post'
            oldStyle
          />
          <Button
            title={<Phrase p='topic_view.reported_content_modal.cancel' />}
            className='btn btn-secondary'
            onClick={this.onCancel}
            size='medium'
            data-qa='cancel-report'
            oldStyle
          />
        </ModalFooter>
      </Modal>
    )
  }
}

export default ReportContentModal
